import React, { FC } from 'react';
import CustomInput from '../../../common/CustomInput';
import useTranslation from '../../../hooks/useTranslation';

const CapacityFormOutboundFields: FC = () => {
  const t = useTranslation();
  return (
    <>
      <CustomInput
        dataTestID={'outbound-truck-capacity'}
        name={'truckFulfilmentCapacityAdjustment'}
        type={'number'}
        label={t('labels.outboundTruckCapacity')}
      />
      <CustomInput
        dataTestID={'outbound-parcel-capacity'}
        name={'parcelFulfilmentCapacityAdjustment'}
        type={'number'}
        label={t('labels.outboundParcelCapacity')}
      />
    </>
  );
};

export default CapacityFormOutboundFields;
